import { Box, Typography } from '@mui/material';
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { MatchingColorsObj } from '../Context/GarmentContext/garmentContextFunctions';
import { LoggingContext } from '../Context/LoggingContext/LoggingContext';

interface ColorSelectProps {
  availableColors: string[];
  setSelectedColor: (newValue: string) => void;
  selectedColor: string;
  matchingColors: MatchingColorsObj;
}

export function findKeyWithThisValue(
  objectToSearch: Record<string, string[]>,
  searchValue: string
): string {
  return Object.keys(objectToSearch).filter((eachKey) =>
    objectToSearch[eachKey].includes(searchValue)
  )[0];
}
export default React.memo(
  ({ availableColors, setSelectedColor, selectedColor, matchingColors }: ColorSelectProps) => {
    const location = useLocation();
    const { addLog } = useContext(LoggingContext);
    return (
      <Box>
        <Typography variant='caption' display='block' gutterBottom sx={{ fontWeight: 'bold' }}>
          Available Colors:{' '}
          <Typography variant='caption' display='inline-block' style={{}}>
            {selectedColor || ''}
          </Typography>
        </Typography>
        <Box
          display='flex'
          flexWrap='wrap'
          justifyContent='flex-start'
          p={1}
          m={0}
          style={{ paddingTop: 0, transform: 'translate( 0)' }}
          onClick={() => addLog('clicked Color Select on Garment Page', location.pathname)}
        >
          {availableColors.length < 1 ? (
            <Box
              p={2}
              m={1}
              boxShadow={2}
              border={2}
              borderColor='transparent'
              bgcolor='grey'
              key='grey'
              style={{ cursor: 'pointer' }}
            >
              No colors have been added yet. Click here to add.
            </Box>
          ) : (
            availableColors.map((eachAvailableColor, index) => {
              if (availableColors.indexOf(eachAvailableColor) !== index) return null; // remove duplicate colors.
              return (
                <Box
                  key={eachAvailableColor}
                  p={2}
                  m={1}
                  boxShadow={2}
                  border={2}
                  borderColor={eachAvailableColor === selectedColor ? 'black' : 'transparent'}
                  bgcolor={findKeyWithThisValue(matchingColors, eachAvailableColor)}
                  onClick={() => {
                    setSelectedColor(eachAvailableColor);
                  }}
                  style={{ cursor: 'pointer' }}
                />
              );
            })
          )}
        </Box>
      </Box>
    );
  }
);
